<template>
  <!-- The split-diamond mark from src/assets/logo.png, redrawn as vector so it stays sharp at any size. -->
  <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
    <polygon points="47,3 0,50 25,50 47,28" fill="#7467b0" />
    <polygon points="0,50 47,97 47,72 25,50" fill="#3b3163" />
    <polygon points="53,3 100,50 75,50 53,28" fill="#c08dbe" />
    <polygon points="100,50 53,97 53,72 75,50" fill="#e0a8cd" />
  </svg>
</template>

<script>
export default {
  name: "LogoMark",
};
</script>
